import { render, staticRenderFns } from "./ReportJ.vue?vue&type=template&id=0870ab50&scoped=true&"
import script from "./ReportJ.vue?vue&type=script&lang=js&"
export * from "./ReportJ.vue?vue&type=script&lang=js&"
import style0 from "./ReportJ.vue?vue&type=style&index=0&id=0870ab50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870ab50",
  null
  
)

export default component.exports